import {
  buildArchitectPortalPreviewSearch,
  parseArchitectPreviewUid,
} from './architectPortalPreviewQuery';

export type StaffPortalPreviewKind = 'architect' | 'designer' | 'engineer';

export function parseStaffPortalPreviewUid(
  search: string | URLSearchParams | null | undefined,
  kind: StaffPortalPreviewKind,
): string | null {
  if (kind === 'architect') return parseArchitectPreviewUid(search);
  const params = typeof search === 'string'
    ? new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
    : search || new URLSearchParams();
  if (params.get('previewAs') !== kind) return null;
  const uid = params.get('uid')?.trim() || '';
  return uid || null;
}

export function staffPortalPreviewSearch(kind: StaffPortalPreviewKind, uid: string): string {
  const id = uid.trim();
  if (!id) return '';
  if (kind === 'architect') return buildArchitectPortalPreviewSearch(id);
  return `?previewAs=${kind}&uid=${encodeURIComponent(id)}`;
}

export function parseStaffPortalPreview(
  search: string | URLSearchParams | null | undefined,
): { kind: StaffPortalPreviewKind; uid: string } | null {
  for (const kind of ['architect', 'designer', 'engineer'] as const) {
    const uid = parseStaffPortalPreviewUid(search, kind);
    if (uid) return { kind, uid };
  }
  return null;
}

export function staffPortalPreviewHref(kind: StaffPortalPreviewKind, uid: string): string {
  const id = uid.trim();
  const path = kind === 'architect' ? '/architect-portal' : '/designer-portal';
  if (!id) return path;
  return `${path}${staffPortalPreviewSearch(kind, id)}`;
}

/** Design Portal is the staff View-as home. */
export function staffPortalPreviewExitHref(): string {
  return '/designer-portal';
}

export function staffPreviewKindForUid(
  uid: string,
  lists: {
    designers: Array<{ uid: string }>;
    architects: Array<{ uid: string }>;
    engineers: Array<{ uid: string }>;
  },
): StaffPortalPreviewKind | null {
  if (lists.architects.some((u) => u.uid === uid)) return 'architect';
  if (lists.engineers.some((u) => u.uid === uid)) return 'engineer';
  if (lists.designers.some((u) => u.uid === uid)) return 'designer';
  return null;
}
